<template>
<div
    @drop.prevent="addFile"
    @dragover.prevent>
  <div
    v-show="!showImportButton"
    v-cloak
    class="upload-area"
    >
    <div class="m-r-5">
      <input
        @change="newFile"
        type="file"
        ref="invButton"
        style="display:none"/>
      </div>
    <div class="info-holder" @click.prevent="addFileWindow">
      <h2 v-if="!file">
        <span>{{ $t('Select your file') }}</span> {{ $t('or drop it here') }}
      </h2>
      <h2 v-if="file && uploadText === ''">
        {{ file.name }}
      </h2>
      <h2 v-else>
        {{ uploadText }}
      </h2>
      <div class="progress-holder">
        <div class="progress-bar-holder m-b-20">
          <span class="progress-bar" :style="{width: uploadProgress + '%'}"></span>
        </div>
        <p v-if="uploadText !== ''">{{ `${uploadProgress}%` }}</p>
        <div v-if="uploadText !== ''">{{ file.name }}</div>
        <div v-if="showWarning">Please select all options before uploading file</div>
        <div v-if="uploadFileError.length > 0">
          <p v-for="(error, index) in uploadFileError"
            :key="`Error-field-${index}`"
            class="m-b-20 error-field">
            {{ error }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- <Btn
    v-show="showImportButton"
    class="brand d-inline-block float-right"
    :btnText="$t('Upload again')"
    @btnClick="addFileWindow" @click.prevent="addFileWindow"/> -->
  </div>
</template>

<script>
import Btn from '@/components/elements/buttons';

/* eslint-disable */
export default {
  name: "UploadArea",
  components: { Btn },
  props: {
    uploadProgress: Number,
    uploadFileError: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadText: '',
    showImportButton: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return{
      file: null,
      showWarning: false,
    };
  },
  methods: {
    showUploadWarning() {
      this.showWarning = true;
      const self = this;
      setTimeout(() => {
        self.showWarning = false;
      }, 3000);
    },
    addFile(e) {
      if(!this.disabled){
        this.file = e.dataTransfer.files[0];
        this.emitFileChange();
      } else {
        this.showUploadWarning();
      }
    },
    addFileWindow() {
      // this.$store.commit('SHOW_NOTIFICATION_BAR', '');
      this.file = null
      if(this.file === null && !this.disabled) {
        this.$refs.invButton.click();
      } else {
        this.showUploadWarning();
      }
    },
    newFile() {
      this.file = this.$refs.invButton.files[0];
      this.emitFileChange();
    },
    emitFileChange() {
      this.$emit('selected', this.file);
    },
    startUpload() {
      this.$emit('startUpload');
    }
  },
}
</script>
